import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext({
    isAuthenticated: false,
    user: null,
    real_user: null,
    switched: false,
    loading: true
});

export const AuthProvider = ({ instance, children }) => {
    const [state, setState] = useState({ isAuthenticated: false, user: null, real_user: null, switched: false, loading: true });

    const isDebug = process.env.NODE_ENV === 'development';
    const bffUrl = isDebug ? 'http://localhost:3001' : '/api';

    // Funzione per tornare alla Home se la sessione scade
    const handleSessionExpired = useCallback(() => {
        if (window.location.pathname !== '/') {
            window.location.href = '/'; 
        } else {
            setState({ isAuthenticated: false, user: null, real_user: null, switched: false, loading: true });
        }
    }, []);

    const checkAuth = useCallback(async () => {
        try {
            // Unica chiamata: chiediamo al BFF stato sessione + dati utente consolidati
            const res = await fetch(`${bffUrl}/logged`, { credentials: 'include' });
            
            // Se il cookie scade (maxAge finito), il server risponde 401 o 403
            if (res.status === 401 || res.status === 403) {
                handleSessionExpired();
                return;
            }

            const data = await res.json();

            if (data.loggedIn && data.user) {
                // Sincronizziamo il context di Piral per i Pilet
                if (instance?.context) {
                    instance.context.dispatch(s => ({
                        ...s,
                        custom: { 
                            ...s.custom, 
                            user: data.user // Contiene già i dati Graph + Roles salvati nel redirect
                        }
                    }));
                }
                
                setState({ isAuthenticated: true, user: data.user, real_user: data.real_user, switched: data.switched, loading: false });
            } else {
                setState({ isAuthenticated: false, user: null, real_user: null, switched: false, loading: true });
            }
        } catch (err) {
            console.error("Auth check failed:", err);
            setState({ isAuthenticated: false, user: null, real_user: null, switched: false, loading: true });
        }
    }, [bffUrl, instance, handleSessionExpired]);

    useEffect(() => {
        checkAuth();

        // Polling ogni 2 minuti: se il cookie Azure/SPID scade, il prossimo ping riporta in Home
        const interval = setInterval(checkAuth, 120000); 

        return () => clearInterval(interval);
    }, [checkAuth]);

    return (
        <AuthContext.Provider value={state}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);